//GSAP
import gsap from "gsap";

//Set Observer Options
const options = {
	root: null, // defaults to document
	rootMargin: '0px',
	threshold: .4
}

// Element to look for in viewport
const target = document.querySelector('.fp-testimonials');

const observer = new IntersectionObserver(fishAni, options);

observer.observe(target);

function fishAni(entries, observer) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			const
				windowWidth = $(window).width(),
				container = '#sea-bg-wrapper',
				allFish = '.sea-fish';

			if (jQuery(allFish).length) {
				//FISH MOTION ON X AXIS
				const fishX = gsap.timeline();

				$(allFish).clone().appendTo(container);

				if (allFish.length) {
					fishX.to(allFish, {
						duration: 60,
						ease: 'none',
						x: windowWidth * -1,
						modifiers: {
							x: gsap.utils.unitize(x => parseFloat(x) % windowWidth)
						},
						repeat: -1
					});
				}

				//FISH MOTION ON Y AXIS
				const fishY = gsap.timeline({
						defaults: {
							duration: 5,
							repeat: -1,
							yoyo: true,
							ease: 'power1.inOut',
							repeatDelay: 0
						}
					}),
					fish_tr = gsap.timeline(),
					fish_br = gsap.timeline();

				fishY.add(fish_tr).add(fish_br);

				if ($('.tr-fish').length) {
					fish_tr.to('.tr-fish', {
						y: 60
					})
				}

				if ($('.br-fish').length) {
					fish_br.to('.br-fish', {
						y: -60
					})
				}

				observer.unobserve(entry.target);
			}
		}
	})
}